import { Alpine as AlpineType } from 'alpinejs';

const FILTER_BUNDLE_SP_API =
  'https://apiv2.loopwork.co/bundleStorefront/filterBundleSellingPlanIds';
const GET_PRODUCT_BUNDLE_DATA_API =
  'https://apiv2.loopwork.co/bundleStorefront/getChildVariants?id=';
const CREATE_BUNDLE_TRANSACTION_API =
  'https://api-service.loopwork.co/bundleTransaction';
const priceFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export default (Alpine: AlpineType) => {
  Alpine.data('productView', (props: any) => ({
    slider: null,
    loading: true,
    selectedSellingPlanId: null,
    productBundleData: null,
    sellingPlans: [],
    loopBundleSellingPlans: [],
    historyPushState: window.location.href.indexOf('/page') > -1 ? false : true,
    ...props,

    async init() {
      this.sellingPlans = this.sellingPlanGroups?.flatMap((spg: any) => {
        return spg?.selling_plans?.map((sp: any) => sp);
      });

      this.setSelectedSellingPlanId(
        this.currentVariantPlanAllocations[0]?.sellingPlanId
      );

      // this.setCurrentVariant(this.defaultVariant.id);
      this.setCurrentVariantByQty(
        this.defaultVariant.main_variant_id,
        this.defaultVariant.qty,
        this.defaultVariant.id
      );

      await this.checkLoopBundleSellingPlans();

      if (this.isBundleProduct) {
        this.productBundleData = await fetch(
          `${GET_PRODUCT_BUNDLE_DATA_API}${this.id}`
        ).then(r => r.json());

        this.setSelectedSellingPlanId(
          this.currentVariantPlanAllocations[0]?.sellingPlanId
        );
      }

      if (!this.variants.length) {
        this.enableSellingPlan = false;
        this.hasSubscription = false;
      }

      if (this.isQuickview) {
        await this.$nextTick();

        this.$refs.blazeSlider
          .querySelector('.blaze-track')
          .append(
            ...this.$refs.images.querySelectorAll(
              '.product-quickview__image-container'
            )
          );

        await this.$nextTick();
      } else {
        const variantId = new URLSearchParams(location.search).get('variant');

        if (!variantId) {
          if (this.currentVariantId && this.historyPushState) {
            // const url = new URL(window.location.href);
            // url.searchParams.set('variant', this.currentVariantId);
            // window.history.pushState({}, '', url.toString());
          }
        } else {
          const parsedVariantId = parseInt(variantId);

          if (
            this.currentVariantId &&
            this.currentVariantId !== parsedVariantId &&
            this.variants.find((variant: any) => variant.id === parsedVariantId)
          ) {
            this.currentVariantId = parsedVariantId;
            this.carouselImages[0] = this.currentVariant.image;
          }
        }
      }

      const { default: BlazeSlider } = await import('blaze-slider');

      this.$nextTick(() => {
        if (this.$refs.blazeSlider) {
          this.slider = new BlazeSlider(this.$refs.blazeSlider, {
            all: {
              loop: true,
              slidesToShow: 5,
              slideGap: '12px',
            },
          });
        }
      });

      this.loading = false;
    },

    get currentImage() {
      return this.carouselImages[this.currentImageIndex];
    },
    get currentVariant() {
      const currentVariant = this?.variants?.length
        ? this.variants.find(
            (variant: any) => variant.id === this.currentVariantId
          )
        : this.defaultVariant;

      return currentVariant;
    },
    get currentVariantPlanAllocations() {
      const allocations = this?.currentVariant?.sellingPlanAllocations?.filter(
        (allocation: { sellingPlanId: number }) => {
          return this.isBundleProduct
            ? this.loopBundleSellingPlans.includes(allocation.sellingPlanId)
            : !this.loopBundleSellingPlans.includes(allocation.sellingPlanId);
        }
      );

      return allocations;
    },
    get fullPrice() {
      return (
        (this.currentVariant.compareAtPriceInCents / 100) *
        this.currentVariantQty
      ).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    },
    get subscriptionPrice() {
      let price;

      if (this.isBundleProduct) {
        const variantId = this.currentVariant.id;
        const selectedSellingPlanId = this.selectedSellingPlanId;
        const value =
          this.productBundleData?.data?.productVariantsFinalValues?.[
            variantId
          ]?.[selectedSellingPlanId];

        if (value) {
          price = priceFormat.format(value);
        }
      } else {
        const allocation = this?.currentVariant?.sellingPlanAllocations.find(
          (allocation: { sellingPlanId: number }) => {
            return allocation.sellingPlanId === this.selectedSellingPlanId;
          }
        );
        
        const priceInCents = allocation?.cosmeticPriceSubscriptionInCents 
          || allocation?.priceInCents;

        price = (
          (priceInCents / 100) * this.currentVariantQty
        ).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      }

      return price;
    },
    get subscriptionServingPrice() {
      const allocation = this?.currentVariant?.sellingPlanAllocations.find(
        (allocation: { sellingPlanId: number }) => {
          return allocation.sellingPlanId === this.selectedSellingPlanId;
        }
      );

      return allocation?.cosmeticServingPriceSubscription 
        || allocation?.servingPrice;
    },
    get subscriptionCupPrice() {
      const allocation = this?.currentVariant?.sellingPlanAllocations.find(
        (allocation: { sellingPlanId: number }) => {
          return allocation.sellingPlanId === this.selectedSellingPlanId;
        }
      );

      let price = allocation?.cosmeticServingPriceSubscription 
        || allocation?.servingPrice;
        
      if (price) {
        price = price.replace("/Serving"," per cup");
      }
      
      return price;
    },
    get price() {
      const basePriceInCents = this.isBundleProduct
        ? this.productBundleData?.data?.productVariantsFinalValues?.[
            this.currentVariant.id
          ]?.['ONETIME'] * 100
        : this.currentVariant.cosmeticPriceOnetimeInCents 
          || this.currentVariant.priceInCents;

      return this.isBundleProduct
        ? priceFormat.format(
            this.productBundleData?.data?.productVariantsFinalValues?.[
              this.currentVariant.id
            ]?.['ONETIME']
          )
        : (
            (basePriceInCents / 100) * this.currentVariantQty
          ).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    },

    get servingPrice() {
      return this.currentVariant.cosmeticServingPriceOnetime 
        || this.currentVariant.servingPrice;
    },
    get discounts() {
      return this.variants.map((variant: any) =>
        this.enableSellingPlan
          ? variant.sellingPlanAllocations.find(
              (allocation: any) =>
                allocation.sellingPlanId == this.selectedSellingPlanId
            ).discount
          : variant.discount
      );
    },
    get selectedSellingPlan() {
      if (!this.sellingPlans) {
        return null;
      }

      const plan = this.sellingPlans.find(
        (sp: { id: number }) => sp.id === this.selectedSellingPlanId
      );
      return plan || null;
    },
    get ctaText() {
      if (!this.variants.length) {
        return 'Not available';
      }

      if (this.currentVariant.available) {
        return `${
          this.enableSellingPlan
            ? this.buttonCtaTextSubscribe || 'Get Started'
            : this.buttonCtaTextOneTime || 'Add To Cart'
        }${
          this.loading
            ? ''
            : ` - ${
                this.enableSellingPlan ? this.subscriptionPrice : this.price
              }`
        }`;
      } else {
        return this.notAvailableButtonText;
      }
    },
    get ctaTextWithoutMoney() {
      if (!this.variants.length) {
        return 'Not available';
      }

      if (this.currentVariant.available) {
        return this.enableSellingPlan
          ? this.buttonCtaTextSubscribe || 'Add To Cart'
          : this.buttonCtaTextOneTime || 'Add To Cart';
      } else {
        return this.notAvailableButtonText;
      }
    },
    get canShowFullPrice() {
      const price = this.isBundleProduct
        ? this.productBundleData?.data?.productVariantsFinalValues?.[
            this.currentVariant.id
          ]?.['ONETIME'] * 100
        : this.currentVariant.cosmeticPriceOnetimeInCents 
          || this.currentVariant.priceInCents;
      
      return (
        this.currentVariant.compareAtPriceInCents &&
        this.currentVariant.compareAtPriceInCents > price
      );
    },
    get variantsDiscountedPrice() {
      const prices = {};
      const variants = this.variants;
      variants.map((v: any) => {
        if (
          !v ||
          !this.selectedSellingPlan ||
          (!this.enableSellingPlan && !v.discount) ||
          (this.enableSellingPlan && !v?.sellingPlanAllocations?.length)
        ) {
          return null;
        }

        const planDiscount = v?.sellingPlanAllocations?.find(
          (allocation: { sellingPlanId: number }) => {
            return allocation.sellingPlanId === this.selectedSellingPlan?.id;
          }
        );

        if (planDiscount?.discount) {
          // @ts-ignore
          prices[v.id] = `+ ${planDiscount?.discount}% Off`;
        }
      });

      return prices;
    },
    get canShowFullPriceSubscription() {
      const selectedSellingPlanId = this.selectedSellingPlanId;
      const allocation = this.currentVariant?.sellingPlanAllocations.find(
        (allocation: any) =>
          allocation?.sellingPlanId == selectedSellingPlanId
      );
      
      const price = this.isBundleProduct
        ? this?.productBundleData?.data?.productVariantsFinalValues?.[
            this.currentVariant.id
          ]?.[selectedSellingPlanId] * 100
        : allocation?.cosmeticPriceSubscriptionInCents 
          || allocation?.priceInCents;
          
      return (
        this.currentVariant.compareAtPriceInCents &&
        this.currentVariant.compareAtPriceInCents > price
      );
    },
    setCurrentImageIndex(index: number) {
      console.log('setCurrentImageIndex', index)
      this.currentImageIndex = index;
    },
    setCurrentVariant(id: any) {
      if (this.currentVariantId !== id) {
        this.currentVariantId = id;
        this.carouselImages[0] = this.currentVariant.image;
        this.slider?.prev(this.currentImageIndex);
        this.currentImageIndex = 0;
        this.currentVariantTitle = this.currentVariant.title.replace('-', ' ');

        if (!this.isQuickview && this.historyPushState) {
          // const url = new URL(window.location.href);
          // url.searchParams.set('variant', this.currentVariantId);
          // window.history.pushState({}, '', url.toString());
        }
      }
    },
    setCurrentVariantByQty(main_id: any, qty: any, id: any) {
      if (this.currentVariantQty !== qty) {
        this.currentVariantId = main_id;
        this.currentVariantQty = qty;
        this.variants.map((variant: any) => {
          if (variant.id == id) {
            this.carouselImages[0] = variant.image;
          }
        });
        // this.slider.prev(this.currentImageIndex);
        this.currentImageIndex = 0;
        this.currentVariantTitle = qty + ' Pack';
      }
    },
    getDiscount(id: any) {
      const variant = this.variants.find((variant: any) => variant.id === id);

      if (
        !variant ||
        (!this.enableSellingPlan && !variant.discount) ||
        (this.enableSellingPlan && !variant?.sellingPlanAllocations?.length)
      ) {
        return null;
      }

      return `+ ${
        this.enableSellingPlan
          ? variant.sellingPlanAllocations.find(
              (allocation: any) =>
                allocation?.sellingPlanId == this.selectedSellingPlanId
            )?.discount
          : variant.discount
      }% Off`;
    },
    setSelectedSellingPlanId(id: number) {
      if (!id || !this.hasSubscription) {
        return false;
      }

      this.enableSellingPlan = true;
      this.selectedSellingPlanId = id;
    },
    async addToCart() {
      if (this.isBundleProduct) {
        await this.loopHandleAddToCart();
        return;
      }

      if (!this.variants.length) return;

      if (this.currentVariant.available) {
        const properties = {} as { [key: string]: any };

        if (this.variants?.length > 1) {
          properties['_variants'] = JSON.stringify(
            this.variants.map((item: any) => ({
              id: item.id,
              title: item.title,
            }))
          );
        }

        const selectedSellingPlan = this.selectedSellingPlan;

        if (this.enableSellingPlan && selectedSellingPlan) {
          properties['_sellingPlanName'] = `${selectedSellingPlan?.name}`;
          properties['_sellingPlanId'] = `${selectedSellingPlan?.id}`;
        }

        await this.$store.cart.addItem(
          {
            quantity: this.currentVariantQty,
            id: this.currentVariant.id,
            ...(this.enableSellingPlan
              ? { selling_plan: selectedSellingPlan?.id }
              : {}),
            properties,
          },
          0 // TODO: Delete this. Free gift handled by Rebuy
        );

        if (this.isQuickview) {
          this.close();
        }

        this.$store.ui.toggleCartDrawer(true);
      } else {
        this.$dispatch('open-notify-me-modal', {
          variantId: this.currentVariant.id,
        });
      }
    },
    async checkLoopBundleSellingPlans() {
      const raw = JSON.stringify({
        domain: window.Shopify.shop,
        sellingPlanIds: this.sellingPlanGroups?.flatMap((spg: any) => {
          return spg?.selling_plans?.map((sp: any) => sp.id);
        }),
        product_shopify_id: this.id,
      });

      await fetch(FILTER_BUNDLE_SP_API, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          accept: 'application/json',
        },
        body: raw,
        redirect: 'follow',
      })
        .then(response => response.json())
        .then(result => {
          this.loopBundleSellingPlans = result.data || [];
        })
        .catch(error => console.error(error));
    },
    nextImage() {
      this.currentImageIndex =
        this.carouselImages.length > this.currentImageIndex + 1
          ? this.currentImageIndex + 1
          : 0;
    },
    prevImage() {
      this.currentImageIndex =
        this.currentImageIndex > 0
          ? this.currentImageIndex - 1
          : this.carouselImages.length - 1;
    },
    async loopHandleAddToCart() {
      const quantity = 1;
      const selectedBundleVariantId = this.currentVariant.id;
      const bundleData = this.productBundleData.data;
      const currentSellingPlanId = this.enableSellingPlan
        ? this.selectedSellingPlanId
        : null;

      const { bundleTransactionId, bundleVariantDiscount } =
        await this.handleBundleTransaction(quantity);
      if (!bundleTransactionId) {
        return;
      }

      const payload = await this.createAddToCartPayloadLoop(
        bundleTransactionId,
        bundleVariantDiscount,
        currentSellingPlanId,
        selectedBundleVariantId,
        quantity,
        bundleData
      );

      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      }).catch(error => {
        console.error('shopifyAddToCartByLoop', error);
      });
    },
    async createAddToCartPayloadLoop(
      bundleTransactionId: any,
      bundleVariantDiscount: any,
      selectedSellingPlan: any,
      selectedBundleVariantId: any,
      quantity: any,
      bundleData: any
    ) {
      const formData = {
        items: [],
        attributes: {
          _loopBundleDiscountAttributes: {},
        },
      } as any;

      const oldAttr = await this.getBundleDiscountAttributesLoop();
      const currentDiscountAttribute = {} as any;
      currentDiscountAttribute[bundleTransactionId] = {
        discountType: bundleVariantDiscount.bundleDiscountType,
        discountValue: bundleVariantDiscount.bundleDiscountValue,
        discountComputedValue: bundleVariantDiscount
          ? selectedSellingPlan
            ? bundleVariantDiscount.spbpDiscount[selectedSellingPlan] * quantity
            : bundleVariantDiscount.bundleDiscountComputedValue * quantity
          : 0,
      };
      formData.attributes._loopBundleDiscountAttributes = JSON.stringify({
        ...oldAttr,
        ...currentDiscountAttribute,
      });

      const selectedBundleVariantProducts =
        bundleData.mapping?.[selectedBundleVariantId].childProducts;
      if (selectedBundleVariantProducts?.length) {
        selectedBundleVariantProducts.forEach((product: any) => {
          const obj = {
            id: product.childVariantId,
            quantity: product.quantity * quantity,
            selling_plan: selectedSellingPlan,
            properties: {
              _bundleId: bundleTransactionId,
              _isPresetBundleProduct: true,
            },
          } as any;
          if (bundleData.showBundleName) {
            obj.properties.bundleName = bundleData?.loopBundleName ?? '';
          } else {
            obj.properties._bundleName = bundleData?.loopBundleName ?? '';
          }
          formData.items.push(obj);
        });
      }
      return formData;
    },
    async getBundleDiscountAttributesLoop() {
      const url = `https://${
        window.Shopify.cdnHost.split('/cdn')[0]
      }/cart.json`;
      const res = await (await fetch(url)).json();

      const loopBundleDiscountAttributes = res.attributes
        ?._loopBundleDiscountAttributes
        ? JSON.parse(res.attributes._loopBundleDiscountAttributes)
        : {};

      const bundleIdsInCart = new Set(
        res.items
          .map((item: any) => item.properties?._bundleId)
          .filter((id: any) => id)
      );

      const filteredAttributes = Object.keys(loopBundleDiscountAttributes)
        .filter(key => bundleIdsInCart.has(key))
        .reduce((obj: any, key) => {
          obj[key] = loopBundleDiscountAttributes[key];
          return obj;
        }, {});

      return filteredAttributes;
    },
    createBundleTransactionPayload(quantity: any) {
      const selectedVariant = this.currentVariant.id;
      const bundleData = this.productBundleData.data;
      let bundleDiscountId = null;
      let bundleVariantDiscount = {};
      if (this.enableSellingPlan) {
        let disc = bundleData?.productVariantDiscountMapping?.[
          selectedVariant
        ]?.find((d: any) => d.purchaseType === 'SUBSCRIPTION');
        if (disc) {
          bundleVariantDiscount = disc;
          bundleDiscountId = disc.bundleDiscountId;
        }
      } else {
        let disc = bundleData?.productVariantDiscountMapping?.[
          selectedVariant
        ]?.find((d: any) => d.purchaseType !== 'SUBSCRIPTION');
        if (disc) {
          bundleVariantDiscount = disc;
          bundleDiscountId = disc.bundleDiscountId;
        }
      }

      if (!bundleDiscountId) {
        return { payload: null, bundleVariantDiscount: null };
      }

      return {
        payload: {
          bundleId: bundleData['bundleId'],
          bundleVariantId: bundleData?.productVariantMapping?.[selectedVariant],
          bundleDiscountId: bundleDiscountId,
          sellingPlanId:
            bundleData?.productVariantSellingPlanMapping?.[
              this.selectedSellingPlan
            ],
          productsQuantity: Number(quantity),
        },
        bundleVariantDiscount,
      };
    },
    async handleBundleTransaction(quantity: any) {
      try {
        const { payload, bundleVariantDiscount } =
          this.createBundleTransactionPayload(quantity);
        const bundleTransactionId = await this.createBundleTransaction(payload);
        return { bundleTransactionId, bundleVariantDiscount };
      } catch (error) {
        console.error(error);
      }
    },
    async createBundleTransaction(payload: any) {
      try {
        const response = await fetch(CREATE_BUNDLE_TRANSACTION_API, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
        console.log('createBundleTransaction', payload, response);

        const bundleTransactionId = await response.json();
        console.log('createBundleTransaction', response, bundleTransactionId);
        return bundleTransactionId.loopBundleGuid;
      } catch (error) {
        console.error('createBundleTransaction', error);
        throw error;
      }
    },
  }));
};
